import querystring from 'querystring'
import * as AT from './_types'
import fetchApi from '../../services/fetchApi'
import { logException } from '../../services/sentry'
import * as patientGroupActions from './patient-groups'
import { chooseCurrentConversation, isCurrConversationEmail } from './current'

export const resetPatient = () => ({ type: AT.PATIENT_SELECT_RESET })

export function selectCurrentPatient(patientId) {
  return {
    type: AT.PATIENT_SELECT_REQUEST,
    patientId,
  }
}

export const addContactInfoToPatient = (contactInfo, locationPhone) => ({
  type: AT.PATIENT_ADD_MSG_CONTACT_INFO,
  contactInfo,
  locationPhone,
})

export const updatePatientConversationIds = (conversationId, convosIdKey) => ({
  type: AT.PATIENT_UPDATE_CONVERSATION_IDS,
  conversationId,
  convosIdKey,
})

export function loadPatientWithRelations(patientId, queryParams) {
  const params = querystring.stringify({ ...queryParams })
  return dispatch =>
    fetchApi(`/patients/${patientId}?with_relations=true&${params}`, 'GET')
      .then(
        ({
          related_patients,
          responsible_parties,
          location,
          patient,
          groups,
        }) => {
          const patientUpdate = {
            patient,
            location,
            groups: groups.map(g => ({ name: g.name, id: g.id })),
            accountHolders: responsible_parties,
            relatedPatients: related_patients,
          }
          // TODO: make a separate state branch for account holders
          // const peopleToAdd = related_patients.concat(patient).concat(responsible_parties)
          // dispatch(patientGroupActions.addPatientsToPatientList(peopleToAdd))

          dispatch({ type: AT.PATIENT_SELECT_REQUEST_SUCCESS, patientUpdate })
        },
      )
      .catch(err => {
        logException(err)
        dispatch({ type: AT.PATIENT_SELECT_REQUEST_FAILURE })
      })
}

export function getPatientAppointments(patientId, locationId = null) {
  const url = `/patients/${patientId}/appointments${
    locationId ? `?location_id=${locationId}` : ''
  }`
  return dispatch =>
    fetchApi(url, 'GET').then(response => {
      dispatch({ type: AT.PATIENT_APPOINTMENTS, appointments: response })
      return response
    })
}

export function getPatientReviews(patientId) {
  return dispatch =>
    fetchApi(`/patients/${patientId}/reviews`, 'GET').then(response => {
      dispatch({ type: AT.PATIENT_REVIEWS, reviews: response })
      return response
    })
}

export function requestReview(patientId, appointmentId, type) {
  const body = JSON.stringify({
    appointment_id: appointmentId,
    message_type: type,
  })
  return dispatch =>
    fetchApi(`/patients/${patientId}/reviews`, 'POST', { body })
      .then(response => {
        dispatch(getPatientAppointments(patientId))
        dispatch(getPatientReviews(patientId))
        return response
      })
      .catch(error => error)
}

export function getPatientMessages(patientId, messagesType) {
  return (dispatch, getState) => {
    dispatch({ type: AT.PATIENT_CONVERSATION_REQUEST })
    return fetchApi(
      `/patients/${patientId}/conversations?messages_type=${messagesType}`,
      'GET',
    )
      .then(response => {
        const { phoneNumbers } = getState().account.user
        const conversationsById = {}
        const emailConversationIds = []
        const textConversationIds = []
        let selectedConvoId = null

        response.forEach(conversation => {
          const {
            messages,
            id: conversationId,
            messages_type: fetchedMessagesType,
            practice_phone: practicePhone,
          } = conversation
          if (
            fetchedMessagesType === 'text' &&
            !phoneNumbers.includes(practicePhone)
          ) {
            return
          }

          conversationsById[conversationId] = conversation

          if (!selectedConvoId && fetchedMessagesType === messagesType) {
            selectedConvoId = conversationId
          }

          fetchedMessagesType === 'email'
            ? emailConversationIds.push(conversationId)
            : textConversationIds.push(conversationId)

          const messageIds = []

          const messagesById = messages.reduceRight((byId, msg) => {
            const { id } = msg
            byId[id] = msg
            messageIds.push(id)

            return byId
          }, {})

          dispatch({
            type: AT.MESSAGES_RECEIVE_IN_BULK,
            messagesById,
          })

          dispatch({
            type: AT.MESSAGES_ADD_TO_CONVO,
            conversationId,
            listOfIds: messageIds,
          })

          dispatch({
            type: AT.CONVERSATIONS_UPDATE_ONE,
            conversationId,
            seen: true,
            subject: conversation.subject,
          })
        })

        if (!selectedConvoId) {
          selectedConvoId = textConversationIds[0] || emailConversationIds[0]
        }

        dispatch({
          type: AT.CONVERSATIONS_RECEIVE,
          listName: 'selected patient',
          conversations: conversationsById,
          idsList: emailConversationIds.concat(textConversationIds).sort(),
        })

        dispatch(chooseCurrentConversation(selectedConvoId))

        if (selectedConvoId) {
          dispatch(isCurrConversationEmail())
        }

        dispatch({
          type: AT.PATIENT_CONVERSATION_REQUEST_SUCCESS,
          emailConversationIds,
          textConversationIds,
        })
      })
      .catch(err => {
        logException(err)
        dispatch({ type: AT.PATIENT_CONVERSATION_REQUEST_FAILURE })
      })
  }
}

export function getPatientNotes(patientId) {
  return dispatch =>
    fetchApi(`/patients/${patientId}/notes`, 'GET').then(response => {
      dispatch({ type: AT.PATIENT_NOTES_RECEIVE, notes: response })
      return response
    })
}

export function createNewPatientNote(patientId, body) {
  return dispatch =>
    fetchApi(`/patients/${patientId}/notes`, 'POST', {
      body: JSON.stringify(body),
    }).then(response => {
      dispatch({ type: AT.PATIENT_NOTES_CREATE, newNote: response })
      return response
    })
}

export function updatePatientNote(patientId, noteId, body, index) {
  return dispatch =>
    fetchApi(`/patients/${patientId}/notes/${noteId}`, 'PATCH', {
      body: JSON.stringify(body),
    }).then(response => {
      dispatch({ type: AT.PATIENT_NOTES_UPDATE, updatedNote: response, index })
      return response
    })
}

export function deletePatientNote(patientId, noteId, index) {
  return dispatch =>
    fetchApi(`/patients/${patientId}/notes/${noteId}`, 'DELETE').then(
      response => {
        dispatch({ type: AT.PATIENT_NOTES_DELETE, index })
        return response
      },
    )
}



// WEBPACK FOOTER //
// ./src/state/actions/selected-patient.js